import { HttpClient, HttpResponse } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AutomapperService } from "../../../../../../core/automapper/automapper.service";
import { BASE_API_URL } from "../../../../../../core/environment.tokens";
import { FeedbackChallengeQueryItem } from "./feedback-challenge-query-item.model";
import { OverreadFeedbackDetail } from "./overread-feedback-detail.model";
import { OverreadFeedbackQueryItem } from "./overread-feedback-query-item.model";
import { OverreadFeedbackQuerySearch } from "./overread-feedback-query-search.model";
import { StandardFilterType } from "./standard-filter-type.enum";

@Injectable({
  providedIn: "root",
})
export class OverreadFeedbackService {

  overreadFeedbackListChange = new BehaviorSubject<OverreadFeedbackQueryItem[]>([]);
  overreadFeedbackListChangeObserver$: Observable<OverreadFeedbackQueryItem[]> = this.overreadFeedbackListChange.asObservable();
  constructor(
    @Inject(BASE_API_URL) private readonly baseApiUrl: string,
    private http: HttpClient,
    private automapper: AutomapperService
  ) { }

  getOverreadFeedbackDetail(chaseId: number): Observable<OverreadFeedbackDetail[]> {
    const url = `${this.baseApiUrl}overreadfeedback/detail?chaseId=${chaseId}`;
    return this.http.get(url).pipe(
      map(this.automapper.curryMany("default", "OverreadFeedbackDetail"))
    );
  }

  getOverreadFeedbackList(overreadFeedbackQuerySearch: OverreadFeedbackQuerySearch): Observable<OverreadFeedbackQueryItem[]> {
    const url = `${this.baseApiUrl}overreadfeedback/query`;
    return this.http.post(url, overreadFeedbackQuerySearch).pipe(
      map(this.automapper.curryMany("default", "OverreadFeedbackQueryItem"))
    );
  }

  getFeedbackChallengeList(standardFilterType: StandardFilterType): Observable<FeedbackChallengeQueryItem[]> {
    const url = `${this.baseApiUrl}overreadfeedback/query`;
    const search: Partial<OverreadFeedbackQuerySearch> = { standardFilterType };
    return this.http.post(url, search).pipe(
      map(this.automapper.curryMany("default", "FeedbackChallengeQueryItem"))
    );
  }

  getFeedbackChallengeStatsCount(): Observable<number> {
    const url = `${this.baseApiUrl}overreadfeedback/challenge/count`;
    return this.http.get(url, { observe: "response" }).pipe(
      map((response: HttpResponse<any>): any => response.ok ? response.body : 0));
  }
}
